module.exports = __webpack_public_path__ + "img/inactive-8.63d80fd4.svg";